const key = '__app';

const nullWindowApp: WindowAppType = {
  placeholder: '',
};

export function initWindowApp() {
  window[key] = window[key] || nullWindowApp;
}